import { ProgressCircle } from '@dynatrace/strato-components/content';

import { loaderOverlay, progressCircle } from './LoaderOverlay.sty.js';

export const LoaderOverlay = ({ gridArea }: { gridArea?: string }) => (
  <>
    {/* Applies a transparent layer to the whole layout */}
    <div className={loaderOverlay} />
    {/* Show the progress circle centered on `gridArea` */}
    <div className={progressCircle} style={{ gridArea }}>
      <ProgressCircle size="large" />
    </div>
  </>
);

LoaderOverlay['displayName'] = 'LoaderOverlay';
